import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { AnnouncementsList } from './List';
import { AnnouncementCreatePage } from './AnnouncementCreatePage';
import { AnnouncementEditPage } from './AnnouncementEditPage';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';

export interface AnnouncementsRoutingProps extends RouteComponentProps {}

export const AnnouncementsRoutingComponent = (props: AnnouncementsRoutingProps) => {
  return (
    <Switch>
      <Route exact path={`${props.match.path}/create`} component={AnnouncementCreatePage} />
      <Route exact path={`${props.match.path}/:uuid/edit`} component={AnnouncementEditPage} />
      <Route exact path={props.match.path} component={AnnouncementsList} />
    </Switch>
  );
};

export const AnnouncementsRouting = compose(withRouter)(AnnouncementsRoutingComponent);
